import { render, staticRenderFns } from "./StepSignaturePositionTemplate.vue?vue&type=template&id=9ebd2ee4&"
import script from "./StepSignaturePositionTemplate.vue?vue&type=script&lang=js&"
export * from "./StepSignaturePositionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StepSignaturePositionTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ebd2ee4')) {
      api.createRecord('9ebd2ee4', component.options)
    } else {
      api.reload('9ebd2ee4', component.options)
    }
    module.hot.accept("./StepSignaturePositionTemplate.vue?vue&type=template&id=9ebd2ee4&", function () {
      api.rerender('9ebd2ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/StepSignaturePositionTemplate.vue"
export default component.exports